import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/opt/build/repo/client/node_modules/gatsby-theme-docz/src/base/Layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "remix-ide"
    }}>{`Remix IDE`}</h1>
    <blockquote>
      <p parentName="blockquote">{`Remix IDE allows developing, deploying and administering smart contracts for Ethereum like blockchains. It can also be used as a learning platform.`}</p>
    </blockquote>
    <h1 {...{
      "id": "resouces-to-learn-remix-ide"
    }}>{`Resouces to learn Remix IDE`}</h1>
    <ul>
      <li parentName="ul">{`📄`}<a parentName="li" {...{
          "href": "https://remix-ide.readthedocs.io/en/latest/"
        }}>{`Official Documentation`}</a></li>
      <li parentName="ul">{`▶️`}<a parentName="li" {...{
          "href": "https://www.youtube.com/watch?v=bZKVfXmzRDw"
        }}>{`Deploy your first Solidity smart contract with Remix IDE`}</a></li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      